<div
    @refresh
    class="view-label-description"
    [ngClass]="{
        'view-label-description--layout-column': layout === 'column',
        'view-label-description--layout-drawer': layout === 'drawer'
    }">    
    <div class="view-label-description__title text-bold">
        {{ (selectedLabel$ | async)?.title }}
    </div>
    <div *ngIf="(selectedLabel$ | async)?.description" class="view-label-description__body">
        {{ (selectedLabel$ | async)?.description }}
    </div>
</div>
